<template>
  <section
    class="hero-widget grid"
    :class="{ 'hero-widget--first': isFirst && !page }"
  >
    <div class="content-wrapper grid">
      <div
        v-viewport-animated="{ mode: 'fade-translate-slow' }"
        class="content"
      >
        <WidgetHeading
          class="title t-hero-l"
          :is-first="isFirst"
          :content="widget.title"
        />
        <div class="text t-hero-m" v-html="nbsp(widget.description)" />
      </div>
      <BaseImage
        v-if="widget.image"
        class="background"
        :image="widget.image"
        :lazyload="lazyImage"
      />
      <VideoIframe
        v-if="widget.video_video_id"
        class="background"
        :video-id="widget.video_video_id"
        :is-vimeo="widget.video_is_vimeo"
        autoplay
      />
    </div>
    <div v-if="widget.icons?.length" class="icons-wrapper">
      <HeroWidgetIconBox
        v-for="(icon, index) in widget.icons"
        :key="`${icon}-${index}`"
        :icon="icon"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import type {
  PublicHeroWidget,
  PublicSimplePageResponse
} from '@/service/__generated-api'
import type { Widget } from '@/types/utils'

const page = inject<PublicSimplePageResponse>('page')
defineProps<Widget<PublicHeroWidget>>()
</script>

<style scoped lang="scss">
.content-wrapper {
  @include column(xs, all);
  position: relative;
  z-index: 0;
  align-items: flex-end;
  justify-items: center;

  width: 100%;
  min-height: 140svw;
  padding-block: rem(60px) rem(100px);
  overflow: hidden;

  @include media-up(md) {
    min-height: 110svw;
    padding-block: rem(80px);
  }

  @include media-up(s-lg) {
    min-height: 50svw;
  }
}

.hero-widget--first {
  .content-wrapper {
    min-height: calc(100svh - $nav-height - rem(110px) - rem(58px));
  }
}

.content {
  @include column(xs, 12);
  @include flex-col;
  gap: rem(20px);
  max-width: rem(700px);
  color: $layout-text-white;
  text-align: center;
}

.title {
  text-shadow: $text-shadow;
}

.background {
  position: absolute;
  inset: 0;
  z-index: -1;
  aspect-ratio: unset;
}

.icons-wrapper {
  @include media-column(
    (
      xs: 12
    )
  );
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: rem(22px);
  align-content: center;
  min-height: rem(244px);
  padding: rem(24px) rem(12px);
  margin-top: -#{rem(40px)};
  background-color: $layout-background-02;
  border-radius: $border-radius;
  box-shadow: $base-shadow;

  @include media-up(md) {
    grid-template-columns: repeat(6, 1fr);
    min-height: rem(140px);
    margin-top: -#{rem(30px)};
  }

  @include media-up(s-lg) {
    padding-inline: rem(48px);
    margin-top: -#{rem(40px)};
  }
}
</style>
